var exports = {
  "Sw": "GuildFolderItem.module__folderContainer___VFdtVE",
  "V8": "GuildFolderItem.module__relative___VFdtVE",
  "o6": "GuildFolderItem.module__collapsedFolder___VFdtVE",
  "yx": "GuildFolderItem.module__collapsedFolderBackground___VFdtVE",
  "sD": "GuildFolderItem.module__miniGuildIcon___VFdtVE",
  "jD": "GuildFolderItem.module__miniGuildIconWithInitials___VFdtVE",
  "mw": "GuildFolderItem.module__folderBadge___VFdtVE",
  "M8": "GuildFolderItem.module__folderBadgeActive___VFdtVE",
  "k9": "GuildFolderItem.module__expandedFolderBackground___VFdtVE",
  "MJ": "GuildFolderItem.module__folderHeader___VFdtVE",
  "mK": "GuildFolderItem.module__folderHeaderButton___VFdtVE",
  "Eh": "GuildFolderItem.module__folderIcon___VFdtVE",
  "QD": "GuildFolderItem.module__expandedGuilds___VFdtVE",
  "h5": "GuildFolderItem.module__folderTooltipContainer___VFdtVE",
  "bO": "GuildFolderItem.module__folderTooltipName___VFdtVE",
  "Il": "GuildFolderItem.module__dropIndicatorTop___VFdtVE",
  "Yc": "GuildFolderItem.module__dropIndicatorBottom___VFdtVE",
  "Zg": "GuildFolderItem.module__dropIndicatorInside___VFdtVE",
};

module.exports = exports;
